"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledTools = require("styled-tools");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Module dependencies.
 */

/**
 * `Wrapper` styled component.
 */
var Wrapper = _styledComponents["default"].span.withConfig({
  displayName: "circles__Wrapper",
  componentId: "sc-i1odou-0"
})(["align-items:center;display:flex;justify-content:center;"]);
/**
 * `Circle` styled component.
 */


var Circle = _styledComponents["default"].span.withConfig({
  displayName: "circles__Circle",
  componentId: "sc-i1odou-1"
})(["animation:", " cubic-bezier(0.55,0.055,0.675,0.19) 0.5s infinite alternate both;background-color:currentColor;border-radius:50%;height:", "px;width:", "px;&:nth-child(2){animation-delay:0.15s;}&:nth-child(3){animation-delay:0.3s;}"], (0, _styledTools.theme)('keyframes.pulse'), (0, _styledTools.prop)('size'), (0, _styledTools.prop)('size'));
/**
 * `Circles` component.
 */


var Circles = function Circles(_ref) {
  var className = _ref.className,
      size = _ref.size;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Circle, {
    size: size
  }), /*#__PURE__*/_react["default"].createElement(Circle, {
    size: size
  }), /*#__PURE__*/_react["default"].createElement(Circle, {
    size: size
  }));
};
/**
 * Export `Circles` component.
 */


var _default = Circles;
exports["default"] = _default;